import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as Copy } from '../../../webcommon/common/Icons/Collapse.svg';
import { noop } from 'lodash';
import defaultStyles from './TradeIdHeaderStyles.module.scss';

const TradeIdHeader = props => (
    <div className={ props.styles.tradeIdWrapper }>
        <div className={ props.styles.tradeIdHeader }>{props.title}</div>
        <div>
            <button
                className={ props.styles.gridButton }
                type="button"
                onClick={ props.onClick }
            >
                <Copy />
            </button>
        </div>
    </div>
);

TradeIdHeader.defaultProps = {
    onClick: noop,
    styles: defaultStyles,
    title: ''
};

TradeIdHeader.propTypes = {
    onClick: PropTypes.func,
    styles: PropTypes.objectOf(PropTypes.string),
    title: PropTypes.string
};

export default TradeIdHeader;
